// Select the existing section header and h1 element
const sectionHeader = document.querySelector('.section-header');
const h1Element = sectionHeader.querySelector('h1');

// Create the new wrapper <div> with class "breadcrumbs"
const breadcrumbsDiv = document.createElement('div');
breadcrumbsDiv.className = 'breadcrumbs';

// Create the new <a> element
const homeLink = document.createElement('a');
homeLink.href = `${window.location.protocol}//${window.location.hostname}`;
homeLink.textContent = 'Home';

// Append the <h1> and <a> elements to the breadcrumbs <div>
breadcrumbsDiv.appendChild(h1Element);
breadcrumbsDiv.prepend(homeLink);

// Append the breadcrumbs <div> to the section header
sectionHeader.prepend(breadcrumbsDiv);

// Function to check and move material-icons-outlined
function moveIcons() {
    document.querySelectorAll('.material-icons-outlined').forEach((icon) => {
        const nextSibling = icon.nextElementSibling;
        if (nextSibling && nextSibling.classList.contains('tag-item') && nextSibling.classList.contains('tag-item')) {
            nextSibling.prepend(icon); // Move the icon inside the tag-item-filter element
        }
    });
}

// Observe for DOM changes to ensure elements are loaded
const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            moveIcons(); // Re-run the move logic when the DOM changes
        }
    }
});

// Start observing the body for changes
observer.observe(document.body, { childList: true, subtree: true });

// Initial run in case elements are already loaded
moveIcons();